import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { LeaveGuestMode } from 'acscp/actions';

interface InjectedDispatchProps {
    leaveGuestMode: () => boolean;
}

export const LoginButtonPresentational: React.SFC<InjectedDispatchProps & {className?: string}> =
    ({leaveGuestMode, className, children}) => (
    <Link className={className} to="/login" onClick={leaveGuestMode}>
        {!!children ? children :
            <FormattedMessage
                id={'components.loginButton'}
                defaultMessage={'Sign In'}
            />
        }
    </Link>
);

function mapDispatchToProps(dispatch: Dispatch, ownProps: {}): InjectedDispatchProps {
    return {
        leaveGuestMode: () => {
            dispatch(new LeaveGuestMode());
            return true;
        },
    };
}

export const LoginButton = connect(undefined, mapDispatchToProps)(LoginButtonPresentational);
